
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;

export class Poker2MovieClipHelper {
    private _targetMc: MovieClip;
    private _callbackFunction: Function;

    /**
     * Play a MovieClip's timeline and executes a callback function when its finished.
     *
     * @param target MovieClip The MovieClip which will be played.
     * @param callback Function The Callback method which will be called when the target MovieClip has reached its last frame.
     *
     */
    public playMovieClip(targetMc: MovieClip, callback: Function): Poker2MovieClipHelper {
        this._targetMc = targetMc;
        this._callbackFunction = callback;

        this._targetMc.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrameTargetMovieClip), false, 0, true);
        this._targetMc.gotoAndPlay(1);

        return this;
    }

    private onEnterFrameTargetMovieClip(event: Event): void {
        var targetMc: MovieClip = event.target as MovieClip;

        if (targetMc.currentFrame == targetMc.totalFrames - 1) {
            targetMc.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrameTargetMovieClip));

            // execute callback
            this._callbackFunction(targetMc);
            this._callbackFunction = null;
            targetMc = null;
        }
    }

    /**
     * Stops timeline animation an removes ENTER_FRAME listener
     */
    public kill(): void {
        if (this._targetMc) {
            this._targetMc.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrameTargetMovieClip));
        }
        this._callbackFunction = null;
        this._targetMc = null;
    }
}
